import "leaflet";
import "hammerjs";
import "showdown";

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import {MaterialModule} from "@angular/material";
import {
  RouterModule,
  PreloadAllModules
} from "@angular/router";

import { AppComponent } from './components/app/app.component';
import { MapComponent } from './components/map/map.component';
import { SpotListComponent } from './components/spot-list/spot-list.component';
import { SpotDetailsComponent } from './components/spot-details/spot-details.component';

import {SafePipe} from "./pipes/safe.pipe";

import {SidenavService} from "./services/sidenav.service";
import {MapService} from "./services/map.service";
import {GuideService} from "./services/guide.service";
import {WindowService} from "./services/window.service";

import { ROUTES } from "./routes";

@NgModule({
  declarations: [
    SafePipe,
    AppComponent,
    MapComponent,
    SpotListComponent,
    SpotDetailsComponent
  ],
  entryComponents: [SpotDetailsComponent],
  imports: [BrowserAnimationsModule, HttpModule, FormsModule, BrowserModule, MaterialModule, RouterModule.forRoot(ROUTES, { useHash: true, preloadingStrategy: PreloadAllModules })],
  providers: [
    GuideService,
    MapService,
    SidenavService,
    { provide: WindowService, useValue: window }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts